import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const buttonTheme: Pick<Components<Theme>, 'MuiButton'> = {
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        variants: [
          {
            props: { variant: 'contained', color: 'promo' },
            style: {
              // set gradient background -- mui uses background-color by default
              background: (theme.vars || theme).palette.promo.gradient,
            },
          },
          {
            props: { variant: 'contained', color: 'promo', disabled: true },
            style: {
              // set background for disabled gradient -- mui uses background-color by default
              background: (theme.vars || theme).palette.action
                .disabledBackground,
            },
          },
        ],
      }),
      startIcon: {
        '&>*:first-of-type.svg-inline--fa': {
          fontSize: 'inherit', // set a restriction on font-awesome icon sizes inside buttons
        },
      },
      endIcon: {
        '&>*:first-of-type.svg-inline--fa': {
          fontSize: 'inherit', // set a restriction on font-awesome icon sizes inside buttons
        },
      },
    },
  },
};
